export default __webpack_public_path__ + "static/media/model-registerstep-new-60.4009e897.png";